import Footer from 'features/App/Footer/Footer'
import HeaderBasic from 'features/App/HeaderBasic/HeaderBasic'
import Navigation from 'features/App/Navigation'
import React from 'react'

const BasicLayout = ({
  component: Component,
  ...rest
}) => {
  return (
    <>
      <div className="headnav">
        <HeaderBasic />
        <Navigation />
      </div>
      <main>
        <Component {...rest} />
      </main>
      <Footer />
    </>
  )
}

export default BasicLayout